export default {
  initialize (seed) {
    this._prng = this.Alea(seed)
  },
  next () {
    return this._prng()
  },
  scrambleArray (arr) {
    return [...arr].sort(() => 0.5 - this.next())
  },
  /*
    Magical PRNG algorithm
    Create a new instance, with a seed.
    Run instance as a function to spit out pseudo-random floats between 0 and 1
    https://github.com/bryc/code/blob/master/jshash/PRNGs.md#alea
  */
  Alea (seed) {
    if (seed === undefined) { seed = +new Date() + Math.random() }
    function Mash () {
      let n = 4022871197
      return function (r) {
        for (let t, s, f, u = 0, e = 0.02519603282416938; u < r.length; u++) {
          s = r.charCodeAt(u); f = (e * (n += s) - (n * e | 0)); n = 4294967296 * ((t = f * (e * n | 0)) - (t | 0)) + (t | 0)
        }
        return (n | 0) * 2.3283064365386963e-10
      }
    }
    return (function () {
      // eslint-disable-next-line one-var
      let m = Mash(), a = m(' '), b = m(' '), c = m(' '), x = 1
      seed = seed.toString(); a -= m(seed); b -= m(seed); c -= m(seed); a < 0 && a++; b < 0 && b++; c < 0 && c++
      return function () {
        const y = x * 2.3283064365386963e-10 + a * 2091639; a = b; b = c
        c = y - (x = y | 0)
        return c
      }
    }())
  }
}
